/* src/app/components/session-info/cost-info/cost-info.component.scss */
ion-text {
  white-space: nowrap;
}
/*# sourceMappingURL=cost-info.component.css.map */
